import { doc, getFirestore, setDoc } from "firebase/firestore";
import { DateTime } from "luxon";
import { UniformRequest, UniformRequestStatus, UniformRequestType } from "../types/UniformRequest";

export const updateUniformRequestStatus = async (uniformRequest: UniformRequest, status: UniformRequestStatus) => {
  const db = getFirestore();

  let updateFields: any = { status };
  if (status === 'Completed') {
    updateFields = {
      ...updateFields,
      dateCompleted: DateTime.utc().toISO(),
    }
  }

  await setDoc(
    doc(db, `Employees/${uniformRequest.idNumber}/UniformRequests/${uniformRequest.id}`),
    updateFields,
    { merge: true }
  );
};

export const updateUniformRequestType = async (uniformRequest: UniformRequest, type: UniformRequestType) => {
  if (uniformRequest.type !== type) {
    const db = getFirestore();
    
    await setDoc(
      doc(db, `Employees/${uniformRequest.idNumber}/UniformRequests/${uniformRequest.id}`),
      { type },
      { merge: true }
    );
    return true;
  }
  return false;
}